import { Fragment } from 'react';
import { Button, FormControl, FormGroup } from '@material-ui/core';

import {
  MenuItemFinder,
  MultipleChoice,
  ProductOfOrder,
  WithoutItems,
} from './components';

import { useSFMainContent } from './hooks';

import makeClasses from './SFMainContent.style';

import type { OrderId } from 'shared/domain';

export function SFMainContent(props: Props) {
  const { orderId, fromChatBtn } = props;

  const {
    lang,
    order,
    showCTA,
    flowStep,
    itemsOutStock,
    handleOnChange,
    handleCTA,
    selectSuggestions,
  } = useSFMainContent({ orderId, fromChatBtn });

  const _classes = makeClasses();

  return (
    <main aria-label='content' className={_classes.content}>
      <section aria-label='order_detail' className={_classes.orderDetail}>
        <header className={_classes.odHeader}>
          <h1>{lang.orderDetail.header.title}</h1>
          <p>{lang.orderDetail.header.description.first}</p>
          <p>{lang.orderDetail.header.description.second}</p>
        </header>
        <FormControl
          fullWidth
          component='main'
          aria-label='products'
          className={_classes.products}
        >
          <FormGroup aria-label='form-group' onChange={handleOnChange}>
            {order.products.map((product, idx) => (
              <Fragment key={product.orderProductId}>
                {idx >= 1 && <div className={_classes.divider} />}
                <ProductOfOrder
                  key={product.orderProductId}
                  product={product}
                />
              </Fragment>
            ))}
          </FormGroup>
        </FormControl>
      </section>

      <section aria-label='flow' className={_classes.flow}>
        <header className={_classes.flowHeader}>
          <h1>{lang.flow.header.title}</h1>
          <p>{lang.flow.header.description.first}</p>
          <p>{lang.flow.header.description.second}</p>
        </header>

        <main className={_classes.flowMain}>
          {flowStep.isWithoutItems && <WithoutItems />}
          {flowStep.isMultipleChoice && <MultipleChoice />}
          {flowStep.isMenuItemFinder && (
            <MenuItemFinder
              orderId={orderId}
              itemsOutStock={itemsOutStock}
              onSelectSuggestions={selectSuggestions}
            />
          )}
        </main>

        <footer className={_classes.flowFooter}>
          {showCTA && (
            <Button
              fullWidth
              variant='contained'
              onClick={handleCTA}
              classes={{ root: _classes.ctaBtn }}
            >
              {flowStep.isMenuItemFinder && lang.flow.footer.cta.singleItem}
              {flowStep.isMultipleChoice && lang.flow.footer.cta.multipleItems}
            </Button>
          )}
        </footer>
      </section>
    </main>
  );
}

interface Props {
  orderId: OrderId;
  fromChatBtn: boolean;
}
